import { render } from "./ChangeEmailPage.vue?vue&type=template&id=01bf825d"
import script from "./ChangeEmailPage.vue?vue&type=script&lang=js"
export * from "./ChangeEmailPage.vue?vue&type=script&lang=js"

import "./ChangeEmailPage.vue?vue&type=style&index=0&id=01bf825d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__